function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { h, Component } from 'preact';
import classNames from 'classnames';
import { nanoid } from 'nanoid/non-secure';
import getFileTypeIcon from "../../utils/getFileTypeIcon.js";
import ignoreEvent from '../../utils/ignoreEvent.js';
import FilePreview from "../FilePreview.js";

var FileCard = /*#__PURE__*/function (_Component) {
  _inherits(FileCard, _Component);

  var _super = _createSuper(FileCard);

  function FileCard(props) {
    var _this;

    _classCallCheck(this, FileCard);

    _this = _super.call(this, props);
    _this.form = document.createElement('form');

    _this.updateMeta = function (newVal, name) {
      _this.setState(function (_ref) {
        var formState = _ref.formState;
        return {
          formState: _objectSpread(_objectSpread({}, formState), {}, _defineProperty({}, name, newVal))
        };
      });
    };

    _this.handleSave = function (e) {
      e.preventDefault();
      var fileID = _this.props.fileCardFor;

      _this.props.saveFileCard(_this.state.formState, fileID);
    };

    _this.handleCancel = function () {
      var file = _this.props.files[_this.props.fileCardFor];

      _this.props.uppy.emit('file-editor:cancel', file);

      _this.props.toggleFileCard(false);
    };

    _this.saveOnEnter = function (ev) {
      if (ev.keyCode === 13) {
        ev.stopPropagation();
        ev.preventDefault();
        var file = _this.props.files[_this.props.fileCardFor];

        _this.props.saveFileCard(_this.state.formState, file.id);
      }
    };

    _this.renderMetaFields = function () {
      var metaFields = _this.getMetaFields() || [];
      var fieldCSSClasses = {
        text: 'uppy-u-reset uppy-c-textInput uppy-Dashboard-FileCard-input'
      };
      return metaFields.map(function (field) {
        var id = "uppy-Dashboard-FileCard-input-".concat(field.id);

        var required = _this.props.requiredMetaFields.includes(field.id);

        return h("fieldset", {
          key: field.id,
          className: "uppy-Dashboard-FileCard-fieldset"
        }, h("label", {
          className: "uppy-Dashboard-FileCard-label",
          htmlFor: id
        }, field.name), field.render !== undefined ? field.render({
          value: _this.state.formState[field.id],
          onChange: function onChange(newVal) {
            return _this.updateMeta(newVal, field.id);
          },
          fieldCSSClasses: fieldCSSClasses,
          required: required,
          form: _this.form.id
        }, h) : h("input", {
          className: fieldCSSClasses.text,
          id: id,
          form: _this.form.id,
          type: field.type || 'text',
          required: required,
          value: _this.state.formState[field.id],
          placeholder: field.placeholder // If `form` attribute is not supported, we need to capture pressing Enter to avoid bubbling in case Uppy is
          // embedded inside a <form>.
          ,
          onKeyUp: 'form' in HTMLInputElement.prototype ? undefined : _this.saveOnEnter,
          onKeyDown: 'form' in HTMLInputElement.prototype ? undefined : _this.saveOnEnter,
          onKeyPress: 'form' in HTMLInputElement.prototype ? undefined : _this.saveOnEnter,
          onInput: function onInput(ev) {
            return _this.updateMeta(ev.target.value, field.id);
          },
          "data-uppy-super-focusable": true
        }));
      });
    };

    var _file = _this.props.files[_this.props.fileCardFor];

    var _metaFields = _this.getMetaFields() || [];

    var storedMetaData = {};

    _metaFields.forEach(function (field) {
      storedMetaData[field.id] = _file.meta[field.id] || '';
    });

    _this.state = {
      formState: storedMetaData
    };
    _this.form.id = nanoid();
    return _this;
  } // TODO(aduh95): move this to `UNSAFE_componentWillMount` when updating to Preact X+.


  _createClass(FileCard, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      // eslint-disable-line react/no-deprecated
      this.form.addEventListener('submit', this.handleSave);
      document.body.appendChild(this.form);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.form.removeEventListener('submit', this.handleSave);
      document.body.removeChild(this.form);
    }
  }, {
    key: "getMetaFields",
    value: function getMetaFields() {
      return typeof this.props.metaFields === 'function' ? this.props.metaFields(this.props.files[this.props.fileCardFor]) : this.props.metaFields;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var file = this.props.files[this.props.fileCardFor];
      var showEditButton = this.props.canEditFile(file);
      return h("div", {
        className: classNames('uppy-Dashboard-FileCard', this.props.className),
        "data-uppy-panelType": "FileCard",
        onDragOver: ignoreEvent,
        onDragLeave: ignoreEvent,
        onDrop: ignoreEvent,
        onPaste: ignoreEvent
      }, h("div", {
        className: "uppy-DashboardContent-bar"
      }, h("div", {
        className: "uppy-DashboardContent-title",
        role: "heading",
        "aria-level": "1"
      }, this.props.i18nArray('editing', {
        file: h("span", {
          className: "uppy-DashboardContent-titleFile"
        }, file.meta ? file.meta.name : file.name)
      })), h("button", {
        className: "uppy-DashboardContent-back",
        type: "button",
        form: this.form.id,
        title: this.props.i18n('finishEditingFile'),
        onClick: this.handleCancel
      }, this.props.i18n('cancel'))), h("div", {
        className: "uppy-Dashboard-FileCard-inner"
      }, h("div", {
        className: "uppy-Dashboard-FileCard-preview",
        style: {
          backgroundColor: getFileTypeIcon(file.type).color
        }
      }, h(FilePreview, {
        file: file
      }), showEditButton && h("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn uppy-Dashboard-FileCard-edit",
        onClick: function onClick(event) {
          // When opening the image editor we want to save any meta fields changes.
          // Otherwise it's confusing for the user to click save in the editor,
          // but the changes here are discarded. This bypasses validation,
          // but we are okay with that.
          _this2.handleSave(event);

          _this2.props.openFileEditor(file);
        },
        form: this.form.id
      }, this.props.i18n('editFile'))), h("div", {
        className: "uppy-Dashboard-FileCard-info"
      }, this.renderMetaFields()), h("div", {
        className: "uppy-Dashboard-FileCard-actions"
      }, h("button", {
        className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary uppy-Dashboard-FileCard-actionsBtn" // If `form` attribute is supported, we want a submit button to trigger the form validation.
        // Otherwise, fallback to a classic button with a onClick event handler.
        ,
        type: 'form' in HTMLButtonElement.prototype ? 'submit' : 'button',
        onClick: 'form' in HTMLButtonElement.prototype ? undefined : this.handleSave,
        form: this.form.id
      }, this.props.i18n('saveChanges')), h("button", {
        className: "uppy-u-reset uppy-c-btn uppy-c-btn-link uppy-Dashboard-FileCard-actionsBtn",
        type: "button",
        onClick: this.handleCancel,
        form: this.form.id
      }, this.props.i18n('cancel')))));
    }
  }]);

  return FileCard;
}(Component);

export default FileCard;